module.exports = __webpack_public_path__ + "img/4.9eb81dc6.jpg";